
import React from "react";
import { useNavigate } from "react-router-dom";
import { services } from "./serviceData";

function LandingService() {

  const navigate = useNavigate();

  return (
    <section id="services" className="bg-[#F8F8FF] py-5">
      <div className="mx-auto max-w-screen-xl px-4">
        <h2 className="mb-8 text-center text-3xl font-bold text-crimson">Our Services</h2>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="group flex flex-col h-full transform overflow-hidden bg-gray-100 rounded-lg shadow-lg transition duration-300 hover:scale-[1.02]"
            >
              <div
                className="h-40 bg-contain bg-no-repeat bg-center"
                style={{ backgroundImage: `url(${service.image})` }}
              />
              <div className="flex flex-col flex-grow p-4">
                <h3 className="mb-2 text-lg font-semibold text-black">{service.title}</h3>
                <p className="text-black text-sm flex-grow">{service.description}</p>
                <div className="flex justify-end mt-4">
                  <button
                    onClick={() => navigate(`/service-detail/${service.id}`)}
                    className="px-4 py-2 rounded-full border border-red-500 text-red-500 font-medium transition-all duration-300 hover:bg-red-500 hover:text-white"
                  >
                    View Detail »
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LandingService;
